import { AccountCreationError } from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getAccountCreationError(): AccountCreationError {
      return getState().error;
    },
    isAccountCreationRequestFailure(): boolean {
      return getState().request.isFailure;
    },
    isAccountCreationRequestPending(): boolean {
      return getState().request.isPending;
    },
    isAccountCreationRequestSuccess(): boolean {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
